import StudentPracQuizProgressData from './StudentPracQuizProgressData';

export default StudentPracQuizProgressData;
